/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState} from 'react'
import {useParams} from "react-router-dom";
import {Company} from "@providers/company/_request";
import {observer} from "mobx-react";
import {useIntl} from "react-intl";
import {useListView} from "../providers/ListViewProvider";
import {useErrors} from "@providers/context/ErrorsProvider";
import {employeeStore} from "@store/employee";
import {localErrorsMessage, roleRoutingAdmin} from "@utils/index";
import {Dropdown, Menu, Space} from 'antd';
import {Filial} from "@providers/filial/_request";
import {filial} from "@store/filial";
import {UsersListLoading} from "@metronic/partials/widgets/tables/_modals/components/loading/UserListLoading";

type Props = {
    elemId: number,
    status:boolean,
    branch?: boolean
}


const ChangeStatus:FC<Props> = observer(({elemId, status, branch=false}) => {

    const [statusChecked, setStatusChecked] = useState<boolean>(status)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const {updateData} = useListView()
    const {id} = useParams()
    const {setError} = useErrors()
    const intl = useIntl()
    const [confirmLoading, setConfirmLoading] = useState<boolean>(false)

    const filials = filial.getFilial



    const widgetMenu = (
        <Menu className='p-7 change_status_group'>
            <p className='text-gray-800 fw-bold'>Изменить статус</p>
           <div >

               <div className={`item_check_status d-flex align-items-center justify-content-between border border-gray-300 mb-3
               ${statusChecked?'active':''}`}

                    onClick={()=>{
                        setStatusChecked(true)
                    }}
               >
                   <div className='d-flex  align-items-center'>
                       <span className='me-5'>
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="28" height="28" rx="6" fill="#ECFDF3"/>
                            <path d="M18 11L12.5 16.5L10 14" stroke="#12B76A" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round"/>
                          </svg>

                       </span>
                       <p className='fw-bold fs-6 text-gray-800 mb-0'>Активный</p>
                   </div>
                   <div>
                       <div className="form-check form-check-custom form-check-solid">
                           <input className="form-check-input"
                                  type="radio"
                                  checked={statusChecked}

                           />
                       </div>
                   </div>
               </div>
               <div className={`item_check_status d-flex align-items-center justify-content-between border border-gray-300 
               ${!statusChecked?'active':''}`}
                    onClick={()=>{
                        setStatusChecked(false)
                    }}
               >
                   <div className='d-flex  align-items-center'>
                       <span className='me-5'>
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="28" height="28" rx="6" fill="#FEF3F2"/>
                            <path d="M17 11L11 17M11 11L17 17" stroke="#F04438" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round"/>
                          </svg>


                       </span>
                       <p className='fw-bold fs-6 text-gray-800 mb-0'>Неактивный</p>
                   </div>
                   <div>
                       <div className="form-check form-check-custom form-check-solid">
                           <input className="form-check-input"
                                  type="radio"
                                  checked={!statusChecked}
                           />
                       </div>
                   </div>
               </div>
           </div>

            <div className='mt-8'>
                <button className='btn btn-light fw-bold me-3' onClick={()=>setModalIsOpen(false)}>
                    Отмена
                </button>
                <button className='btn btn-primary fw-bold' onClick={()=>changeStatusSubmit()}>
                    Применить
                </button>
            </div>
        </Menu>
    );


    async function changeStatusSubmit(){
        setModalIsOpen(false)
        setConfirmLoading(true)
        if(branch&&id){
            await Filial.patchFilial(id, elemId.toString(),{active:statusChecked, id: Number(elemId)})
                .then((response)=>{
                    const mapped = filials.map((item) => {
                        if (item.id === Number(elemId)) {
                            return response.data.result
                        }
                        return item
                    })
                    filial.setFilial(mapped)
                })
                .catch((err)=>{
                    setStatusChecked(status)
                    const message = localErrorsMessage('change-status', 'message-match', err?.response?.data?.message, intl)
                    setError({status: err?.response?.status, message: message, isError: true})
                }).finally(() => setConfirmLoading(false))
        }else{
            await Company.partiallyEdit( {active: statusChecked, id: Number(id)})
                .then(()=>{
                    updateData()
                })
                .catch((err)=>{
                    setStatusChecked(status)
                    const message = localErrorsMessage('change-status', 'message-match', err?.response?.data?.message, intl)
                    setError({status: err?.response?.status, message: message, isError: true})
                }).finally(() => setConfirmLoading(false))
        }

    }






    return (
        <>
            {confirmLoading && <UsersListLoading/>}
            {
                roleRoutingAdmin('action', employeeStore.getRole, 'change-status')?(<Dropdown overlay={widgetMenu}  open={modalIsOpen} >
                    <a onClick={(e) => {
                        e.preventDefault()
                        setModalIsOpen(!modalIsOpen)
                    }}>
                        <Space>
                            Изменить статус
                        </Space>
                    </a>
                </Dropdown>):''
            }
        </>
    )
})

export {ChangeStatus}
